export default {
  SET_CURRENT_USER (state, currentUserData) {
    state.currentUser = currentUserData
  },
  SET_CURRENT_STORE (state, currentStore) {
    state.currentStore = currentStore
  }
}
